import { FC } from 'react'
import { IIcon } from '../typings'
import { BoxProps } from '@mui/material/Box'
import Hospital from './Hospital'
import Stethoscope from './Stethoscope'
import Book from './Book'
import Hands from './Hands'
import MyCare from './MyCare'
import CheckMark from './CheckMark'
import ThumbsUp from './ThumbsUp'
import ThumbsDown from './ThumbsDown'
import Camera from './Camera'
import Brand from './Brand'
import Location from './Location'
import Star from './Star'
import Handshake from './Handshake'
import SelfService from './SelfService'
import Care from './Care'
import Trophy from './Trophy'
import Wellness from './Wellness'
import Lightbulb from './Lightbulb'
import Conversation from './Conversation'
import Magnify from './Magnify'
import Home from '@mui/icons-material/Home'
import Call from '@mui/icons-material/Call'
import Clipboard from './Clipboard'
import Bed from './Bed'
import Gears from './Gears'
import SearchMagnify from './SearchMagnify'
import ClearSearch from './ClearSearch'
import ChatRGB from './ChatRGB'
import OnlineAd from './OnlineAd'
import PhoneRGB from './PhoneRGB'
import BrandonlyInitial from './OptumInitialIcon'
import MagnifyingGlass from './MagnifyingGlass'
import AutoAwesome from './AutoAwesome'
import HeartRGB from './HeartRGB'
import XRGB from './XRGB'
import CheckmarkRGB from './CheckmarkRGB'
import CheckMarkOrange from './CheckMarkOrange'
import SearchMagnifyOn from './SearchMagnifyOn'
import SafetyLock from './SafetyLock'
import OBGYN from './OBGYN'
import Chat from './Chat'
import ThumbsUpOrange from './ThumbsUpOrange'
import TargetArrow from './TargetArrow'
import HeartHandshake from './HeartHandshake'
import BuildingIcon from './BuildingIcon'
import MentalHealthIcon from './mentalHealth'
import ChatIcon from './ChatIcon'
import HeartSearchIcon from './HeartSearchIcon'
import FlowerIcon from './FlowerIcon'
import PersonBadgeIcon from './PersonBadgeIcon'

const Icon: FC<{ name: IIcon } & BoxProps<'svg'>> = ({ name, ...boxProps }) => {
  let Comp: FC<BoxProps<'svg'>>
  switch (name) {
    case 'hospital':
      Comp = Hospital
      break
    case 'book':
      Comp = Book
      break
    case 'my-care':
      Comp = MyCare
      break
    case 'hands':
      Comp = Hands
      break
    case 'checkmark':
      Comp = CheckMark
      break
    case 'thumbs-up':
      Comp = ThumbsUp
      break
    case 'thumbs-down':
      Comp = ThumbsDown
      break
    case 'auto-awesome':
      Comp = AutoAwesome
      break
    case 'camera':
      Comp = Camera
      break
    case 'brand':
      Comp = Brand
      break
    case 'location':
      Comp = Location
      break
    case 'star':
      Comp = Star
      break
    case 'trophy':
      Comp = Trophy
      break
    case 'handshake':
      Comp = Handshake
      break
    case 'self-service':
      Comp = SelfService
      break
    case 'care':
      Comp = Care
      break
    case 'wellness':
      Comp = Wellness
      break
    case 'lightbulb':
      Comp = Lightbulb
      break
    case 'conversation':
      Comp = Conversation
      break
    case 'magnify':
      Comp = Magnify
      break
    case 'home':
      Comp = Home as unknown as FC<BoxProps<'svg'>>
      break
    case 'call':
      Comp = Call as unknown as FC<BoxProps<'svg'>>
      break
    case 'clipboard':
      Comp = Clipboard as unknown as FC<BoxProps<'svg'>>
      break
    case 'bed':
      Comp = Bed as unknown as FC<BoxProps<'svg'>>
      break
    case 'gears':
      Comp = Gears as unknown as FC<BoxProps<'svg'>>
      break
    case 'search-magnify':
      Comp = SearchMagnify as unknown as FC<BoxProps<'svg'>>
      break
    case 'search-magnify-on':
      Comp = SearchMagnifyOn as unknown as FC<BoxProps<'svg'>>
      break
    case 'clear-search':
      Comp = ClearSearch as unknown as FC<BoxProps<'svg'>>
      break
    case 'chatrgb':
      Comp = ChatRGB as unknown as FC<BoxProps<'svg'>>
      break
    case 'phonergb':
      Comp = PhoneRGB as unknown as FC<BoxProps<'svg'>>
      break
    case 'onlinead':
      Comp = OnlineAd as unknown as FC<BoxProps<'svg'>>
      break
    case 'brand-minimal':
      Comp = BrandonlyInitial
      break
    case 'magnifying-glass':
      Comp = MagnifyingGlass
      break
    case 'safety-lock':
      Comp = SafetyLock
      break
    case 'heart-rgb':
      Comp = HeartRGB
      break
    case 'x-rgb':
      Comp = XRGB
      break
    case 'checkmark-rgb':
      Comp = CheckmarkRGB
      break
    case 'ob-gyn':
      Comp = OBGYN
      break
    case 'chat':
      Comp = Chat
      break
    case 'thumbs-up-orange':
      Comp = ThumbsUpOrange
      break
    case 'target-arrow':
      Comp = TargetArrow
      break
    case 'heart-handshake':
      Comp = HeartHandshake
      break
    case 'checkmark-orange':
      Comp = CheckMarkOrange
      break
    case 'building':
      Comp = BuildingIcon
      break
    case 'mental-health':
      Comp = MentalHealthIcon
      break
    case 'chat-icon':
      Comp = ChatIcon
      break
    case 'flower-icon':
      Comp = FlowerIcon
      break
    case 'person-badge-icon':
      Comp = PersonBadgeIcon
      break
    case 'heart-search-icon':
      Comp = HeartSearchIcon
      break
    case 'stethoscope':
    default:
      Comp = Stethoscope
      break
  }
  return <Comp {...boxProps} />
}
export default Icon
